export const ucFirst = (str: string): string =>
  str.length >= 2 ? `${str.charAt(0).toUpperCase()}${str.slice(1).toLowerCase()}` : str.toUpperCase();

export const htmlDecode = (input: string) => {
  const doc = new DOMParser().parseFromString(input, 'text/html');
  return doc.documentElement.textContent;
};
